export default __webpack_public_path__ + "static/2302-a45820e87061f6cc9fc390790ebb5958.gif";